document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 1100) {
        console.log('Screen width is too small — typing effect disabled.');
        return;
    }

    const searchTextElement = document.querySelector('.search__text');

    if (!searchTextElement) {
        console.warn('Element with class "search__text" not found.');
        return;
    }

    // if (collectionNames.length === 0) {
    //     console.warn('No collections found.');
    //     return;
    // }

    let collectionIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function typeEffect() {
        const collectionNames = [
          "Accessories & Barware",
          "All Gifts",
          "Red Wines",
          "Rosé Wines",
          "White Wines",
          "French Wines",
          "Wine Deals",
          "Wedding Wines"
        ]
        const currentCollection = collectionNames[collectionIndex];
        const currentText = isDeleting
            ? currentCollection.substring(0, charIndex - 1)
            : currentCollection.substring(0, charIndex + 1);

        searchTextElement.textContent = currentText;

        if (!isDeleting && charIndex < currentCollection.length) {
            charIndex++;
            setTimeout(typeEffect, 100);
        } else if (isDeleting && charIndex > 0) {
            charIndex--;
            setTimeout(typeEffect, 50);
        } else {
            setTimeout(() => {
                isDeleting = !isDeleting;
                if (!isDeleting) {
                    collectionIndex = (collectionIndex + 1) % collectionNames.length;
                }
                typeEffect();
            }, 1500);
        }
    }

    typeEffect();
});


// account page tab section code
class TabSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupTabs();
  }

  setupTabs() {
    const tabTitles = this.querySelectorAll('.tab-title');
    const tabContents = this.querySelectorAll('.tab-content');

    tabTitles.forEach((title) => {
      title.addEventListener('click', () => {
        const targetId = title.getAttribute('data-tab');

        // Remove active class from all tabs and contents
        tabTitles.forEach((t) => t.classList.remove('active'));
        tabContents.forEach((c) => c.classList.remove('active'));

        // Add active class to clicked tab and corresponding content
        title.classList.add('active');
        this.querySelector(`#${targetId}`)?.classList.add('active');
      });
    });
  }
}

customElements.define('tab-section', TabSection);



// filter page price range filter change then refresh the page 
document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.price-range__slider');

  if (!sliders.length) return; // No sliders found

  sliders.forEach(slider => {
    if (slider && typeof slider.noUiSlider !== 'undefined' && slider.noUiSlider.on) {
      slider.noUiSlider.on('change', function () {
        location.reload(); // Refresh page when slider changes
      });
    }
  });
});

